module.exports = __webpack_public_path__ + "static/media/ckn_restaurante_nuevo.e1ba0fa2.jpg";